import { render, staticRenderFns } from "./ToolBar.vue?vue&type=template&id=4f0b4bf5&"
var script = {}
import style0 from "./ToolBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ToolBar.vue"
export default component.exports